import { TripPlacesInput } from '../../lib/types/models/trip-places/trip-places-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateTripPlace(data: UpdateInput<TripPlacesInput>) {
  const { id, ...rest } = data
  return restApiClient.url(constructApiUrl(API.tripPlaces.update.url, { id })).patch(rest)
}
